<template>
  <div>
    <Breadcrumbs :title="$t('sales.satlarm')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <h2>{{ $t('sales.satlarm') }}</h2>
      <div class="row">
        <div class="col-lg-8">
          <div
            v-if="purchases.length<1"
            class="alert alert-info"
          >
            {{ $t('sales.heBirUurluSatMliyyatQeydAlnmamdr') }}
          </div>

          <div
            v-for="(o,i) in purchases"
            :key="i"
            class="card"
          >
            <div
              class="card-body"
              @click.prevent="$router.push(`/dashboard/request/${o.request.id}`)"
            >
              <div class="row">
                <div class="col-6 pointer">
                  <p class="lead">
                    {{ $t('offersList.soru') }}
                  </p>

                  #{{ o.request.requestType }}{{ buildLongId(o.request.id) }}
                  <code><em>{{ $t('dashboardCompany.key', {moment: getMoment(o.request.logTime)}) }}</em></code>

                  <div class="mb-2 lead font-weight-bold">
                    {{ o.request.title }}
                  </div>
                </div>

                <div class="col-6">
                  <p class="lead">
                    {{ $t('offersList.mllif') }}
                  </p>

                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <img
                          :src="getPhoto(o.request.user.photo,'thumbnailCropped')"
                          class="img-thumbnail rounded-circle"
                          style="height: 50px;"
                          :alt="$t('offersList.avatar')"
                        >
                      </div>
                      <div>
                        <span class="text-dark">
                          {{ o.request.user.name }}  {{ o.request.user.surname }}
                        </span> <br>
                        <span class="text-primary ">
                          {{ o.request.company.name }} {{ getCompanyFormat(o.request.company.format) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="p-0 m-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <p class="lead">
                    {{ $t('purchases.qiymtlndirm') }}
                  </p>

                  <div v-if="o.procurementRate === null && openRateBlock !== o.id">
                    <a
                      class="btn btn-warning"
                      @click.prevent="openRateBlock = o.id"
                    >{{ $t('purchases.dyrlndir2') }}</a>
                  </div>
                  <div v-else-if="o.procurementRate">
                    <div class="text-warning">
                      <i
                        v-for="i in 5"
                        :key="i"
                        aria-hidden="true"
                        :class="['fa', 'fa-2x', o.procurementRate>=i?'fa-star':'fa-star-o']"
                      />
                      <span class="h3 ml-3">{{ o.procurementRate.toFixed(1) }}</span>
                    </div>
                    <code><em>{{ $t('dashboardCompany.key', {moment: getMoment(o.procurementRateTime)}) }}</em></code>
                    <div class="lead">
                      {{ o.procurementRateComment }}
                    </div>
                  </div>
                  <div v-else-if="openRateBlock === o.id">
                    <form @submit.prevent="submitRateOrderForm(o.id)">
                      <div class="mb-3">
                        <label>{{ $t('purchases.rating') }}</label>

                        <div class="text-warning">
                          <i
                            :class="['fa', 'fa-3x', rate>0?'fa-star':'fa-star-o']"
                            aria-hidden="true"
                            @click="rate=1"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>1?'fa-star':'fa-star-o']"
                            aria-hidden="true"
                            @click="rate=2"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>2?'fa-star':'fa-star-o']"
                            aria-hidden="true"
                            @click="rate=3"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>3?'fa-star':'fa-star-o']"
                            aria-hidden="true"
                            @click="rate=4"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>4?'fa-star':'fa-star-o']"
                            aria-hidden="true"
                            @click="rate=5"
                          />
                        </div>
                      </div>

                      <div class="mb-3">
                        <label>{{ $t('purchases.qeydiniz') }}</label>
                        <textarea
                          v-model="rateComment"
                          class="form-control"
                          required
                        />
                      </div>

                      <div class="my-3">
                        <button
                          type="submit"
                          class="btn btn-success mr-3"
                        >
                          {{ $t('purchases.dyrlndir') }}
                        </button>
                        <button
                          type="submit"
                          class="btn btn-outline-secondary"
                          @click="openRateBlock=0"
                        >
                          {{ $t('companyProfile.lvEt2') }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-6">
                  <p class="lead">
                    {{ $t('sales.satMbli') }}
                  </p>

                  <p
                    v-if="o.amount <=0"
                    class="text-danger"
                  >
                    {{ $t('sales.qiymtSatnalmaTrfindnDaxilEdilir') }}
                  </p>
                  <div v-else-if="o.amount>0">
                    <code><em>{{ $t('dashboardCompany.key', {moment: getMoment(o.amountTime)}) }}</em></code>
                    <div class="lead">
                      {{ $t('sales.oamountAzn', {amount: o.amount}) }}
                    </div>
                    <p>{{ $t('sales.qiymtSatnalmaTrfindnDaxilEdilir') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{
                  $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {
                    name: company.name,
                    getCompanyFormat: getCompanyFormat(company.format)
                  })
                }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }}
                <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getSales, rateOffer} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import moment from "moment/moment";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      purchases: [],
      openRateBlock: 0,

      rate: 0,
      rateComment: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {

    this.getPurchases();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPurchases() {
      getSales(this.token).then(data => {
        if (data.code === 200) {
          this.purchases = data.sales;
        } else {
          this.$router.push({name: 'changeAccount', query: {next: '/dashboard/sales'}});
        }
      })
    },
    submitRateOrderForm(id) {

      if (this.rate > 0) {

        rateOffer(this.token, id, this.rate, this.rateComment).then(data => {

          if (data.code === 200) {
            this.$swal({
              title: this.$t("tskkrlr"),
              text: this.$t("purchases.qeydeAlindi"),
              icon: 'success'
            })
            this.getPurchases();
            this.openRateBlock = 0;
            this.rate = 0;
            this.rateComment = '';
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("purchases.ulduzlar"),
          icon: 'warning'
        })
      }

    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
